module.exports = __webpack_public_path__ + "static/mortage2021-3b6de26b4773a91dbcb298964a1e622d.jpg";